import { DigestQueryFilter } from "../CandyApiClient/DigestApiClient/Types/DigestQueryFilter";

import { PicklistRequestV2 } from "./Types/PicklistRequestV2";
import { serializeToString as serializeDigestFilterColumnToString } from "./Serializers/DigestFilterColumnSerializer";
import { serializeToString as serializeDigestLogicalFilterToString } from "./Serializers/DigestLogicalFilterSerializer";

export const buildPicklistRequest = (filter?: DigestQueryFilter): PicklistRequestV2 => {
    if (filter == undefined) {
        return {};
    }

    const picklistFilter = convertToPicklistFilter(filter);
    return {
        filter: picklistFilter,
        skip: filter?.skip,
        take: filter?.take,
        tree: filter?.isTree,
    };
};

export const convertToPicklistFilter = (queryFilter?: DigestQueryFilter): string | undefined => {
    const filter = queryFilter?.filter;
    if (filter == undefined) {
        return undefined;
    }

    if ("column" in filter) {
        return serializeDigestFilterColumnToString(filter, queryFilter?.isTree);
    }

    if ("operands" in filter) {
        return serializeDigestLogicalFilterToString(filter);
    }

    return undefined;
};
